module.exports = __webpack_public_path__ + "img/touzi.3f821220.jpg";